export enum ECookiesState {
	accepted = 'accepted',
	rejected = 'rejected',
}